var render = function render(){var _vm=this,_c=_vm._self._c;return _c('permission-form',{attrs:{"permission":_vm.newPermission}})
}
var staticRenderFns = []

export { render, staticRenderFns }